//@flow
import _ from 'lodash';
import * as React from 'react';
import { TableHeaderColumn } from 'react-bootstrap-table';
import connect from 'react-redux/es/connect/connect';
import TopoTitleComponente from '../../components/PageTitle/TopoTitleComponente';
import ListagemPage from '../../components/templates/ListagemPage';
import TopoListagem from '../../components/Topo/TopoListagem';
import { objectsConstants } from '../../_constants/objects.constants';
import { tableHelper } from '../../_helpers/tableHelper';
import { usuarioFinanceiroService } from '../../_services/usuarioFinanceiro.service';
import UsuarioFinanceiroListFilter from './UsuarioFinanceiroListFilter';

const columns = [
  {
    path: 'foto',
    title: '',
    isKey: false,
    isAvatar: true,
    dataSort: false,
    propsMidiaId: 'foto.id',
    className: 'avatar-list',
    width: '100px',
    notExport: true,
  },
  {
    path: 'nome',
    pathFilter: 'nome',
    title: 'Nome do usuário',
    isKey: false,
    dataSort: true,
    className: 'nomeProprio column-bold',
    width: '22%',
  },
  {
    path: 'empresa.nome',
    pathFilter: 'empresa.nome',
    title: 'Empresa',
    isKey: false,
    dataSort: true,
    className: 'column-bold',
    width: '20%',
  },
  {
    path: 'role.role.description',
    pathFilter: 'role.role.description',
    title: 'Perfil',
    isKey: false,
    dataSort: true,
    className: 'column-bold',


  },

  {
    path: 'cpfCnpj',
    pathFilter: 'cpfCnpj',
    title: 'CPF',
    isKey: true,
    dataSort: true,

  },
  {
    path: 'email',
    pathFilter: 'email',
    title: 'E-mail',
    isKey: false,
    dataSort: true,
    width: '250px'

  },

  {
    path: 'origem',
    pathFilter: 'origem',
    title: 'Origem do registro',
    isKey: false,
    dataSort: true,
    className: 'column-bold',
    isOrigem: true
  },

  {
    path: 'status',
    pathFilter: 'status',
    title: 'Ativo',
    dataSort: true,
    yesNo: true
  },
];

const endPoint = '/UsuarioFinanceiro/novo';
const endPointView = '/UsuarioFinanceiro/view/';
class UsuarioFinanceiroListagemPage extends React.PureComponent<{}, State> {
  constructor(props) {
    super(props);
    let fields = _.map(
      _.filter(columns, function (coluna) {
        return !coluna.notExport;
      }),
      function (coluna) {
        return coluna.path;
      }
    );
    let labels = _.map(
      _.filter(columns, function (coluna) {
        return !coluna.notExport;
      }),
      function (coluna) {
        return coluna.title;
      }
    );
    this.state = {
      labels,
      fields,
    };
  }

  handleRowClick = (row: e) => {
    this.props.history.push(endPointView + row.id);
  };

  handleNewButton = (row: e) => {
    this.props.history.push(endPoint);
    // this.props.history.push({
    //   pathname: endPoint,
    //   state: {
    //     titlePage: 'Usuário',
    //   },
    // });
  };

  render() {
    const tableColumn = _.map(columns, (column, index) => (
      <TableHeaderColumn
        key={index}
        dataField={column.path}
        dataFormat={tableHelper.renderCustom}
        formatExtraData={column}
        isKey={column.isKey}
        dataSort={column.dataSort}
        hidden={column.hidden}
        width={column.width}
        className={column.classname}
      >
        {column.title}
      </TableHeaderColumn>
    ));

    let filter = {
      extension: this.props.extension
        ? this.props.extension
        : this.props.user.extension,
    };

    return (
      <React.Fragment>
        <TopoTitleComponente
          mainTitle={objectsConstants.TITULO_PAGINA_USUARIOS}
          subTitle=" "
          canBack={false}
        />
        <TopoListagem
          securityActionDo={objectsConstants.VIEW}
          securityActionOn={objectsConstants.CRUD_USUARIOS_FINANCEIRO}
          buttonActionClassName={'btn-light'}
          buttonAction={() => {
            this.handleNewButton();
          }}
          securityActionIcon={'icon-btn-add'}
          securityActionName={'Novo usuário'}
        ></TopoListagem>
        <ListagemPage
          title={'Usuários'}
          showNewButton={false}
          delete={() => { }}
          service={usuarioFinanceiroService}
          defaultOrder={'nome'}
          defaultDirection={'asc'}
          defaultFilter={filter}
          onRowClick={this.handleRowClick}
          FormFilter={UsuarioFinanceiroListFilter}
          controller="api/usuario"
          fields={this.state.fields}
          labels={this.state.labels}
          columns={columns}
        >
          {tableColumn}
        </ListagemPage>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  };
}

export default connect(mapStateToProps)(UsuarioFinanceiroListagemPage);
